@if (!!options) {
  <mat-radio-group [class]="class" color="primary" [formControl]="formControl">
    @for (opt of options | async; track opt) {
      <mat-radio-button [value]="opt.value">
        @if (!!opt.icon) {
          <ng-icon [name]="opt.icon"></ng-icon>
        }
      {{opt.label}}</mat-radio-button>
    }
  </mat-radio-group>
}